<template>
  <div class="breadcrumbs">
    <nav class="breadcrumbs__nav">
      <ul class="breadcrumbs__list ">
        <li class="breadcrumbs__list-item">
          <a href="/"><span itemprop="name">Home</span></a>
        </li>
        <li
          v-for="(item, index) in breadcrumbs"
          :key="index"
          class="breadcrumbs__list-item"
        >
          <a :href="item.url"
            ><span>{{ item.name }}</span></a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState} from "vuex";
export default {
  name: "Breadcrumbs",
  computed: {
    ...mapState("products", ["breadcrumbs"]),
  },
};
</script>